angular.module('nv.singleStudent').component('studentCreditGapsPanelGapPlans', {
  // tslint:disable-next-line:max-line-length
  template: require('./student-credit-gaps-panel-gap-plans.html'),
  bindings: {
    student: '=',
    school: '=',
    studentGapPlans: '=',
    isRestricted: '<',
  },
  controller: 'StudentCreditGapsPanelGapPlansCtrl',
});
